export enum LanguageSlug {
  Pl = 'pl',
  De = 'de',
  Ru = 'ru',
  En = 'en',
}
